import styled from 'styled-components';
import { container, fontSize, spacing } from 'theme';

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: ${spacing('xl4')} auto;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: ${spacing('xl')};
  padding-left: ${spacing('md')};
  padding-right: ${spacing('md')};
`;

export const StyledDesc = styled.p`
  font-size: ${fontSize('md')};
  line-height: 1.5;
  margin-top: 0;

  &.isTop {
    margin-top: -${spacing('md')};
    margin-bottom: 0;
  }
`;
